/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GroupRoleCategoryData model module.
 * @module model/GroupRoleCategoryData
 * @version 1.0
 */
class GroupRoleCategoryData {
    /**
     * Constructs a new <code>GroupRoleCategoryData</code>.
     * @alias module:model/GroupRoleCategoryData
     */
    constructor() { 
        
        GroupRoleCategoryData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GroupRoleCategoryData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GroupRoleCategoryData} obj Optional instance to populate.
     * @return {module:model/GroupRoleCategoryData} The populated <code>GroupRoleCategoryData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GroupRoleCategoryData();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('gnbName')) {
                obj['gnbName'] = ApiClient.convertToType(data['gnbName'], 'String');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbName')) {
                obj['lnbName'] = ApiClient.convertToType(data['lnbName'], 'String');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('subName')) {
                obj['subName'] = ApiClient.convertToType(data['subName'], 'String');
            }
            if (data.hasOwnProperty('groupNo')) {
                obj['groupNo'] = ApiClient.convertToType(data['groupNo'], 'Number');
            }
            if (data.hasOwnProperty('readonly')) {
                obj['readonly'] = ApiClient.convertToType(data['readonly'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GroupRoleCategoryData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GroupRoleCategoryData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['gnbName'] && !(typeof data['gnbName'] === 'string' || data['gnbName'] instanceof String)) {
            throw new Error("Expected the field `gnbName` to be a primitive type in the JSON string but got " + data['gnbName']);
        }
        // ensure the json data is a string
        if (data['lnbName'] && !(typeof data['lnbName'] === 'string' || data['lnbName'] instanceof String)) {
            throw new Error("Expected the field `lnbName` to be a primitive type in the JSON string but got " + data['lnbName']);
        }
        // ensure the json data is a string
        if (data['subName'] && !(typeof data['subName'] === 'string' || data['subName'] instanceof String)) {
            throw new Error("Expected the field `subName` to be a primitive type in the JSON string but got " + data['subName']);
        }

        return true;
    }


}



/**
 * @member {Number} gnbNo
 */
GroupRoleCategoryData.prototype['gnbNo'] = undefined;

/**
 * @member {String} gnbName
 */
GroupRoleCategoryData.prototype['gnbName'] = undefined;

/**
 * @member {Number} lnbNo
 */
GroupRoleCategoryData.prototype['lnbNo'] = undefined;

/**
 * @member {String} lnbName
 */
GroupRoleCategoryData.prototype['lnbName'] = undefined;

/**
 * @member {Number} subNo
 */
GroupRoleCategoryData.prototype['subNo'] = undefined;

/**
 * @member {String} subName
 */
GroupRoleCategoryData.prototype['subName'] = undefined;

/**
 * @member {Number} groupNo
 */
GroupRoleCategoryData.prototype['groupNo'] = undefined;

/**
 * @member {Boolean} readonly
 */
GroupRoleCategoryData.prototype['readonly'] = undefined;






export default GroupRoleCategoryData;

